<template>
	<v-form ref="form" v-model="form.valid" lazy-validation>
		<slot
			:rules="rules"
			:form="form"
			:inputColor="inputColor"
			:canEdit="canEdit"
			:update="update"
		></slot>
	</v-form>
</template>

<script>
import _ from "lodash";
import PhoneNumber from "awesome-phonenumber";

import { mapGetters, mapMutations } from "vuex";

export default {
	props: {
		// the name of the edit module's getter
		formType: String,
	},

	data: () => ({
		form: {
			valid: true,
			data: {},
		},
	}),

	computed: {
		...mapGetters("userEdit", ["canEdit"]),

		rules() {
			const emailRgx = /^[\w._-]+@([\w_-]+\.)+[\w_-]{2,}$/;
			// there definately is a better way to disable the rules than doing this (!this.canEdit), can't think it out rn
			return {
				required: (v) =>
					!this.canEdit ||
					!!_.trim(v || "").length ||
					"This field is required!",

				requiredIf: (condition) => (v) =>
					!condition || !!_.trim(v || "").length || "This field is required!",

				email: (v) =>
					!this.canEdit || emailRgx.test(v || "") || "This email is not valid!",

				maxLength: (length) => (v) =>
					!this.canEdit ||
					length >= (v || "").length ||
					"Maximum characters exceeded!",

				pastDate: (v) =>
					!this.canEdit ||
					new Date(v) <= new Date() ||
					"Date cannot be in the future!",

				phone: (v) =>
					!this.canEdit ||
					!v ||
					new PhoneNumber(v, "US").isValid() ||
					"This phone number is not valid!",
			};
		},

		inputColor() {
			return this.canEdit ? "primary" : "unset";
		},

		originalData() {
			return this.$store.getters["userEdit/" + this.formType];
		},
	},

	watch: {
		canEdit(val) {
			if (!val) {
				this.handleCancelEdit();
			}
		},
		originalData: {
			handler(data) {
				this.resetForm(data);
			},
			deep: true,
		},
	},

	mounted() {
		this.resetForm(this.originalData);
	},

	methods: {
		...mapMutations("userEdit", {
			update: "SET_UPDATED_DATA",
			resetUpdated: "RESET_UPDATED",
		}),
		validate() {
			// Should be called by parent to validate data
			return this.$refs.form.validate();
		},

		handleCancelEdit() {
			// revert form back to original user data
			this.$refs.form.resetValidation();
			this.resetForm(this.originalData);
		},

		resetForm(data = {}) {
			this.form.data = { ...data };
			this.resetUpdated();
		},
	},
};
</script>
